import { TableItemActionType } from '../enums/table-item-action-type';
import { TableItemActionVisibility } from '../types/table-item-action-visibility';
import { HtmlAnchorTarget, isNil, Nillable } from '@web/utils';
import { TableItemActionCommand } from '../types/table-item-action-command';
import { TableItemActionRouterLink } from '../types/table-item-action-router-link';
import { TableItemActionQueryParams } from '../types/table-item-action-query-params';
import { TableItemActionUrl } from '../types/table-item-action-url';
import { Icon } from '../../icon/enums/icon';
import { TableItemActionSeverity } from '../types/table-item-action-severity';

export class TableItemAction<Item, Key> {
  public constructor(
    public readonly key: Key,
    public readonly type: TableItemActionType,
    public readonly tooltip: string,
    public readonly icon: Icon,
    public readonly visibility: TableItemActionVisibility<Item>,
    public readonly children?: Nillable<Array<TableItemAction<Item, Key>>>,
    public readonly command?: Nillable<TableItemActionCommand<Item>>,
    public readonly routerLink?: Nillable<TableItemActionRouterLink<Item>>,
    public readonly queryParams?: Nillable<TableItemActionQueryParams<Item>>,
    public readonly url?: Nillable<TableItemActionUrl<Item>>,
    public readonly target?: Nillable<HtmlAnchorTarget>,
    public readonly severity?: Nillable<TableItemActionSeverity>,
  ) {}

  public haveChildren(): boolean {
    if (isNil(this.children)) {
      return false;
    }

    return this.children?.length > 0;
  }

  public isCommandType(): boolean {
    return this.checkType(TableItemActionType.Command);
  }

  public isRouterLinkType(): boolean {
    return this.checkType(TableItemActionType.RouterLink);
  }

  public isUrlType(): boolean {
    return this.checkType(TableItemActionType.Url);
  }

  private checkType(type: TableItemActionType): boolean {
    return this.type === type;
  }
}
